const Ach = [
  {
    year: '2017',
    image: '../static/media/expertise.7183e2cb0ebafb28b8d3.jpg',
    title: 'Global Water Intelligence',
  },

  {
    year: '2018',
    image: '../static/media/expertise.7183e2cb0ebafb28b8d3.jpg',
    title: 'Asia Pacific',
  },
]

export default Ach
